import { render, staticRenderFns } from "./PublicBroadcast.vue?vue&type=template&id=154acd9e"
import script from "./PublicBroadcast.vue?vue&type=script&lang=js"
export * from "./PublicBroadcast.vue?vue&type=script&lang=js"
import style0 from "./PublicBroadcast.vue?vue&type=style&index=0&id=154acd9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154acd9e')) {
      api.createRecord('154acd9e', component.options)
    } else {
      api.reload('154acd9e', component.options)
    }
    module.hot.accept("./PublicBroadcast.vue?vue&type=template&id=154acd9e", function () {
      api.rerender('154acd9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/MeetingRoom/PublicBroadcast.vue"
export default component.exports